import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { APP_INITIALIZER, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PublicComponent } from './public/public.component';
import { PrivateComponent } from './private/private.component';
import { HeaderComponent } from './public/header/header.component';
import { HomeComponent } from './public/home/home.component';
import { LoginComponent } from './public/login/login.component';
import { OutletSelectionComponent } from './private/outlet-selection/outlet-selection.component';
import { WINDOW_PROVIDERS } from './services/window.service'
import { FooterComponent } from './public/footer/footer.component';
import { SidemenuComponent } from './private/sidemenu/sidemenu.component';
import { HeaderPrivateComponent } from './private/header/header.component';
import { BranchSelectionComponent } from './private/branch-selection/branch-selection.component';
import { OutletManagerComponent } from './private/outlet-manager/outlet-manager.component';
import { UserManagementComponent } from './private/outlet-manager/user-management/user-management.component';
import { userManagmentTable } from './private/outlet-manager/user-management/user-manegment-table/user-manegment-table';
import { ModalComponent } from './shared/modal/modal.component';
import { DropDownListComponent } from './shared/drop-down-list/drop-down-list';
import { CashierComponent } from './private/cashier/cashier.component';
import { ReceiptsComponent } from './private/cashier/receipts/receipts.component';
import { ModeComponent } from './private/cashier/receipts/mode/mode.component';
import { ProductGroupComponent } from './private/cashier/receipts/product-group/product-group.component';
import { ProductTypeComponent } from './private/cashier/receipts/product-type/product-type.component';
import { ShipperComponent } from './private/cashier/receipts/shipper/shipper.component';
import { ConsigneeDetailsComponent } from './private/cashier/receipts/consignee-details/consignee-details.component';
import { ServicesComponent } from './private/cashier/receipts/services/services.component';
import { ShippmentItemsComponent } from './private/cashier/receipts/shippment-items/shippment-items.component';
import { CreateEditReceiptComponent } from './private/cashier/receipts/create-edit-receipt/create-edit-receipt.component';
import { OneReceiptComponent } from './private/cashier/receipts/one-receipt/one-receipt.component';
import { ReceiptScannerComponent } from './private/cashier/receipts/one-receipt/receipt-scanner/receipt-scanner.component';
//import { SignaturePadModule } from 'angular2-signaturepad';
import { AdditionalChargesComponent } from './private/cashier/receipts/additional-charges/additional-charges.component';
import { OperationsComponent } from './private/operations/operations.component';
import { WarehouseManagementComponent } from './private/operations/warehouse-management/warehouse-management.component';
import { CreateEditAisleComponent } from './private/operations/warehouse-management/create-edit-aisle/create-edit-aisle.component';
import { AisleComponent } from './private/operations/warehouse-management/aisle/aisle.component';
import { PaymentComponent } from './private/cashier/receipts/one-receipt/payment/payment.component';
import { BranchManagementComponent } from './private/outlet-manager/branch-management/branch-management.component';
import { WorkingHoursComponent } from './private/outlet-manager/branch-management/working-hours/working-hours.component';
import { ReportsManagementComponent } from './private/outlet-manager/branch-management/reports-management/reports-management.component';
import { FormsModule } from '@angular/forms';
import { RateCalculatorComponent } from './private/cashier/rate-calculator/rate-calculator.component';
import { PosScannerComponent } from './shared/pos-scanner/pos-scanner.component';
import { InventoryComponent } from './private/operations/inventory/inventory.component';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { ConfigService, ConfigModule } from './services/endpoint.config.service';
import { EntitySelectionComponent } from './private/outlet-selection/entity-selection/entity-selection.component';
import { AddEditUserComponent } from './private/outlet-manager/user-management/add-edit-user/add-edit-user.component';
import { FindExistUserComponent } from './private/outlet-manager/user-management/add-edit-user/find-exist-user/find-exist-user.component';
import { UserSettingsComponent } from './private/outlet-manager/user-management/add-edit-user/user-settings/user-settings.component';
import { CashierSettingsComponent } from './private/outlet-manager/user-management/add-edit-user/user-settings/cashier-settings/cashier-settings.component';
import { ErrorService } from './services/error.service';
import { Interceptor } from './interceptor';
import { ToastrModule } from 'ngx-toastr';
import { DataTransferService } from './services/DataTransferService';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { NgxUiLoaderModule, NgxUiLoaderRouterModule, NgxUiLoaderConfig } from 'ngx-ui-loader';
import { GlobalDropDownListComponent } from './shared/global-drop-down-list/global-drop-down-list.component';
import { PostalComponent } from './private/cashier/receipts/postal/postal.component';
import { UserAccountSearchComponent } from './private/outlet-manager/user-management/add-edit-user/user-settings/user-account-search/user-account-search.component';
import { OrderByPipe } from './pipes/order-by.pipe';
import { CommodityComponent } from './private/cashier/receipts/commodity/commodity.component';
import { InboundAwbComponent } from './private/cashier/receipts/inbound-awb/inbound-awb.component';
import { CategoryComponent } from './private/cashier/receipts/category/category.component';
import { MiscAwbDetailsComponent } from './private/cashier/receipts/misc-awb-details/misc-awb-details.component';
import { ReceiptTableComponent } from './private/cashier/receipts/one-receipt/receipt-table/receipt-table.component';
import { DiscountCalculatorComponent } from './private/cashier/receipts/one-receipt/discount-calculator/discount-calculator.component';
import { WebcamModule } from 'ngx-webcam';
import { SearchReceiptComponent } from './private/cashier/receipts/search-receipt/search-receipt.component';
import { CashoutComponent } from './private/cashier/cashout/cashout.component';
import { FoucsDirective } from './directives/foucs.directive';
import { SettingsComponent } from './private/settings/settings.component';
import { FocusDirective } from './directives/my-focus.directive';
import { RedirectManagerComponent } from './private/redirect-manager/redirect-manager.component';
import { AgentModalComponent } from './shared/agent-modal/agent-modal.component';
import { OrderByDatePipe } from './pipes/order-by-date.pipe';
import { UnauthorizedComponent } from './public/unauthorized/unauthorized.component';
import { DashboardComponent } from './private/dashboard/dashboard.component';
import { DatepickerModule } from 'ng2-datepicker';
import { DashboardCardsComponent } from './private/dashboard/dashboard-cards/dashboard-cards.component';
import { DashboardTabelComponent } from './private/dashboard/dashboard-tabel/dashboard-tabel.component';
import { BarcodeReaderComponent } from './private/dashboard/barcode-reader/barcode-reader.component';
import { QRCodeModule } from 'angularx-qrcode';
import { ShipmentReceivingComponent } from './private/operations/shipment-receiving/shipment-receiving.component';
import { ValidateCourierComponent } from './private/operations/shipment-receiving/validate-courier/validate-courier.component';
import { ShipmentScanningComponent } from './private/operations/shipment-receiving/shipment-scanning/shipment-scanning.component';
import { JobsHandoverComponent } from './private/operations/jobs-handover/jobs-handover.component';
import { ReceivingsComponent } from './private/operations/receivings/receivings.component';
import { _ShipmentReceivingComponent } from './private/operations/_shipment-receiving/shipment-receiving1.component';
import { CommercialInvoiceComponent } from './private/cashier/receipts/commercial-invoice/commercial-invoice.component';
import { ScannerSettingsComponent } from './private/settings/scanner-settings/scanner-settings.component';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatNativeDateModule} from '@angular/material/core';
import { DropOffAwbComponent } from './private/cashier/receipts/dropoff-awb/dropoff-awb.component';
import {TranslateLoader, TranslateModule, TranslateService} from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { Lang } from './shared/lang';
import { MatSelectSearchModule } from 'mat-select-search';
import { MatSelectModule } from '@angular/material/select';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { TopazSettingsComponent } from './private/settings/topaz-settings/topaz-settings.component';
import { GenerateCommercialInvoiceComponent } from './private/cashier/receipts/generate-commercial-invoice/generate-commercial-invoice.component';
import { CommercialDetailsItemsComponent } from './private/cashier/receipts/commercial-details-items/commercial-details-items.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { PackagingAwbComponent } from './private/cashier/receipts/packaging-awb/packaging-awb.component';
import { WebcamModalComponent } from './private/cashier/receipts/one-receipt/webcam-modal/webcam-modal.component';
import { PackagingOutboundComponent } from './private/cashier/receipts/packaging-outbound/packaging-outbound.component';
import { AddToReceiptDropOffRTIComponent } from './private/cashier/receipts/add-to-receipt-drop-off-rti/add-to-receipt-drop-off-rti.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MfaComponent } from './private/mfa/mfa.component';

const services = [{
  ErrorService
}];

const ngxUiLoaderConfiguration: NgxUiLoaderConfig =
{
  bgsPosition: "bottom-center",
  "bgsColor": "#00ACC1",
  "bgsOpacity": 0.5,
  "bgsSize": 60,
  "bgsType": "ball-scale-multiple",
  "blur": 5,
  "fgsColor": "#eee",
  "fgsPosition": "center-center",
  "fgsSize": 60,
  "fgsType": "ball-spin-clockwise",
  "gap": 24,
  "logoPosition": "center-center",
  "logoSize": 250,
  "masterLoaderId": "master",
  "overlayBorderRadius": "0",
  "overlayColor": "rgba(40, 40, 40, 0.8)",
  "pbColor": "rgba(220, 41, 30, 1)",
  "pbDirection": "ltr",
  "pbThickness": 3,
  "hasProgressBar": true,
  "text": "",
  "textColor": "#FFFFFF",
  "textPosition": "center-center",
  "threshold": 500
}

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    PublicComponent,
    PrivateComponent,
    HeaderComponent,
    HomeComponent,
    FooterComponent,
    LoginComponent,
    OutletSelectionComponent,
    HeaderPrivateComponent,
    FooterComponent,
    SidemenuComponent,
    OutletManagerComponent,
    UserManagementComponent,
    userManagmentTable,
    ModalComponent,
    CashierComponent,
    ReceiptsComponent,
    ModeComponent,
    ProductGroupComponent,
    DropDownListComponent,
    OperationsComponent,
    WarehouseManagementComponent,
    CreateEditAisleComponent,
    ProductTypeComponent,
    AisleComponent,
    PaymentComponent,
    ShipperComponent,
    OneReceiptComponent,
    ReceiptScannerComponent,
    ConsigneeDetailsComponent,
    ServicesComponent,
    ShippmentItemsComponent,
    CreateEditReceiptComponent,
    AdditionalChargesComponent,
    PaymentComponent,
    BranchManagementComponent,
    WorkingHoursComponent,
    ReportsManagementComponent,
    RateCalculatorComponent,
    PosScannerComponent,
    InventoryComponent,
    BranchSelectionComponent,
    EntitySelectionComponent,
    AddEditUserComponent,
    FindExistUserComponent,
    UserSettingsComponent,
    CashierSettingsComponent,
    GlobalDropDownListComponent,
    PostalComponent,
    UserAccountSearchComponent,
    OrderByPipe,
    CommodityComponent,
    InboundAwbComponent,
    DropOffAwbComponent,
    CategoryComponent,
    MiscAwbDetailsComponent,
    ReceiptTableComponent,
    DiscountCalculatorComponent,
    SearchReceiptComponent,
    CashoutComponent,
    FoucsDirective,
    SettingsComponent,
    FocusDirective,
    RedirectManagerComponent,
    AgentModalComponent,
    OrderByDatePipe,
    UnauthorizedComponent,
    DashboardComponent,
    DashboardCardsComponent,
    DashboardTabelComponent,
    BarcodeReaderComponent,
    ShipmentReceivingComponent,
    ValidateCourierComponent,
    ShipmentScanningComponent,
    JobsHandoverComponent,
    ReceivingsComponent,
    _ShipmentReceivingComponent,
    CommercialInvoiceComponent,
    GenerateCommercialInvoiceComponent,
    CommercialDetailsItemsComponent,
    ScannerSettingsComponent,
    TopazSettingsComponent,
    PackagingAwbComponent,
    WebcamModalComponent,
    PackagingAwbComponent,
    PackagingOutboundComponent,
    AddToReceiptDropOffRTIComponent,
    MfaComponent
  ],
    entryComponents: [AddToReceiptDropOffRTIComponent], 

  imports: [
    MatSnackBarModule,
    TranslateModule.forRoot({
        loader: {
            provide: TranslateLoader,
            useFactory: HttpLoaderFactory,
            deps: [HttpClient]
        }
    }),
    NgbModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
   // SignaturePadModule,
    WebcamModule,
    QRCodeModule,
    FormsModule,
    NgSelectModule,
    HttpClientModule,
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfiguration),
    NgxUiLoaderRouterModule,
    LoadingBarHttpClientModule,
    DatepickerModule,
    MatFormFieldModule, 
    MatInputModule, 
    MatDatepickerModule,
    MatNativeDateModule,
    MatSelectModule,
    MatCardModule,
    MatSelectSearchModule,
    MatButtonModule,
    ToastrModule.forRoot({
      timeOut: 2000,
      positionClass: 'toast-bottom-right',
      preventDuplicates: false,
    })
  ],
  providers: [
    WINDOW_PROVIDERS,
    ConfigService,
    ConfigModule.init(),
    { provide: HTTP_INTERCEPTORS, useClass: Interceptor, multi: true },
    DataTransferService,
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [TranslateService],
      multi: true
    }

  ],
  schemas: [NO_ERRORS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule { }

export function appInitializerFactory(translate: TranslateService) {
  return () => {
    translate.setDefaultLang(Lang.en);
    return translate.use(Lang.en);
  };
}
